<div mat-dialog-title>Select priority</div>
<div class="content-container">
  <ul class="dialog-content" mat-dialog-content *ngFor="let prio of prioMgr.values; let i=index">
    <li [ngClass]="{'selected-priority': i == selection}" matRipple
      [appStatus]="{switch: prio, case: {high: 'alert-danger', medium: 'alert-warning', low: 'alert-success'}}"
      [looks]="'priority'" (click)="selection = i">
      <mat-icon *ngIf="i == selection">check_circle_outline</mat-icon>
      {{prio | titlecase}}
    </li>
  </ul>
</div>
<div class="action-btns" mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close (click)="onSuccess()">Ok</button>
</div>